import {Grid, Tab, Tabs} from '@material-ui/core';
import {observer} from 'mobx-react-lite';
import {Fragment, useEffect, useState} from 'react';
import {TabPanel} from '../Core/UI';
import {FormsPanel} from './Forms';
import RootStore from '../Core/mobx/RootStore';

export const CMPanel = observer(() => {
    const [tabIndex, setTabIndex] = useState(0);
    const [loading, setLoading] = useState(false);

    const forms = RootStore.caseManagerStore.forms;

    useEffect(() => {
        (async () => {
            if (!forms?.length) {
                setLoading(true);
                await RootStore.caseManagerStore.getForms();
                setLoading(false);
            }
        })();
    }, []);

    return (
        <div style={{width: '100%', textAlign: 'center'}}>
            {loading ? (
                <div>loading... please wait...</div>
            ) : (
                <Fragment>
                    <Tabs
                        value={tabIndex}
                        centered={true}
                        onChange={(e, v) => {
                            setTabIndex(v);
                        }}
                    >
                        <Tab label="All Forms" />
                        <Tab label="Pre-qualification Forms" />
                        <Tab label="Pre-approval Forms" />
                    </Tabs>
                    <Grid>
                        <TabPanel value={tabIndex} index={0}>
                            <FormsPanel filter={'all'} forms={forms}></FormsPanel>
                        </TabPanel>
                        <TabPanel value={tabIndex} index={1}>
                            <FormsPanel filter={'qual'} forms={forms}></FormsPanel>
                        </TabPanel>
                        <TabPanel value={tabIndex} index={2}>
                            <FormsPanel filter={'approval'} forms={forms}></FormsPanel>
                        </TabPanel>
                    </Grid>
                </Fragment>
            )}
        </div>
    );
});
